import * as types from './types'
import { Delivery, activityAt } from './types'
import { createReducer } from 'app/state/utils'

export interface TradeDocumentDeliveryState {
  deliveries: Delivery[]
}

const initialState: TradeDocumentDeliveryState = { deliveries: [] }

// A sub-trade can hold one delivery per packet type (ADR_LOS-026), so the
// upsert key is (subTradeId, packetType) — tolerating records that predate
// the packetType field by treating them as the settled packet.
const deliveryKey = (d: Delivery) => `${d.subTradeId}::${d.packetType ?? 'settled'}`

const reducer = createReducer(initialState)({
  // Upsert rather than replace: callers load different subsets (the panel
  // loads every row, the actions bar loads only the current selection), so a
  // wholesale replace would drop deliveries for sub-trades outside the latest
  // request — e.g. an already-Sent row reverting to no status after a bulk
  // Mark Sent on its siblings.
  [types.LOAD_DELIVERIES]: (state: TradeDocumentDeliveryState, action: any) => {
    const incoming: Delivery[] = action.payload ?? []
    const byKey = new Map(state.deliveries.map(d => [deliveryKey(d), d]))
    // Last-activity-wins merge (LOS-6471): a record's activity time is the
    // latest of preparedAt / sentAt / failedAt. A lagging read carrying an
    // older snapshot must never overwrite fresher state in ANY direction —
    // an old Sent over a fresh re-Prepared, an old PrepFailed over a fresh
    // retry, an old Prepared over a fresh Sent, and every other status pair.
    incoming.forEach(d => {
      const existing = byKey.get(deliveryKey(d))
      if (existing && activityAt(d) < activityAt(existing)) return
      byKey.set(deliveryKey(d), d)
    })
    return { ...state, deliveries: Array.from(byKey.values()) }
  },
})

export default reducer
